import { render, staticRenderFns } from "./HeaderMobile.vue?vue&type=template&id=6f32916d"
import script from "./HeaderMobile.vue?vue&type=script&lang=js"
export * from "./HeaderMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f32916d')) {
      api.createRecord('6f32916d', component.options)
    } else {
      api.reload('6f32916d', component.options)
    }
    module.hot.accept("./HeaderMobile.vue?vue&type=template&id=6f32916d", function () {
      api.rerender('6f32916d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/header/HeaderMobile.vue"
export default component.exports